import { call, put, takeEvery } from "redux-saga/effects"

import api from "../../utilities/api"
import * as apiErrorHelpers from "../../helpers/apiErrorHelpers"
import * as sessionHelpers from "../../helpers/sessionHelpers"
import { AUTHENTICATION_TOKEN } from "../../constants/application"
import { ERROR, FAILURE, SUCCESS } from "../../constants/notification"
import i18n from "../../utilities/i18n"
import { orderCancelledEvents } from "../../helpers/googleAnalyticsHelpers"
import store from "../configureStore"
import { IMPERSONATED_BY } from "../../constants/users"

export function* maintenanceUpdate(action) {
  try {
    yield put({
      type: "MAINTENANCE_UPDATE_REQUESTED"
    })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    const { users } = store.getState()

    const orderId = action.payload.submissionData.id

    let apiPayload = {
      ...action.payload.submissionData
    }

    if (localStorage.getItem(IMPERSONATED_BY) !== null) {
      apiPayload = {
        ...apiPayload,
        impersonated_by: localStorage.getItem(IMPERSONATED_BY)
      }
    }

    const request = {
      url: `/orders/${orderId}`,
      body: apiPayload
    }

    const response = yield call(api.utility.put, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: "MAINTENANCE_UPDATE_SUCCEEDED",
      payload: { order: response.body }
    })

    const afterRequestData = {
      alertMessage: i18n.t("notificationsReminder:maintenanceUpdated"),
      alertType: SUCCESS
    }

    yield call(action.callback, SUCCESS, afterRequestData)
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({
      type: "MAINTENANCE_UPDATE_FAILED"
    })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors),
      alertType: ERROR
    }

    yield call(action.callback, FAILURE, afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // maintenanceApproval()

export function* maintenanceApproval(action) {
  try {
    yield put({
      type: "MAINTENANCE_APPROVAL_REQUESTED"
    })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    const { users } = store.getState()

    const orderId = action.payload.submissionData.id

    let apiPayload = {
      ...action.payload.submissionData
    }

    if (localStorage.getItem(IMPERSONATED_BY) !== null) {
      apiPayload = {
        ...apiPayload,
        impersonated_by: localStorage.getItem(IMPERSONATED_BY)
      }
    }

    const request = {
      url: `/orders/${orderId}`,
      body: apiPayload
    }

    const response = yield call(api.utility.put, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: "MAINTENANCE_APPROVAL_SUCCEEDED"
    })

    const afterRequestData = {
      alertMessage: i18n.t("notificationsReminder:maintenanceApproved"),
      alertType: SUCCESS,
      response: response.body
    }

    yield call(action.callback, SUCCESS, afterRequestData)
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({
      type: "MAINTENANCE_APPROVAL_FAILED"
    })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors),
      alertType: ERROR
    }

    yield call(action.callback, FAILURE, afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // maintenanceApproval()

export function* maintenanceCancelation(action) {
  try {
    yield put({ type: "MAINTENANCE_CANCELATION_REQUESTED" })

    api.setAuthApi({
      Authorization: sessionHelpers.getApplicationCookie(AUTHENTICATION_TOKEN)
    })

    const { users } = store.getState()

    const orderId = action.payload.submissionData.id

    let apiPayload = {
      ...action.payload.submissionData
    }

    if (localStorage.getItem(IMPERSONATED_BY) !== null) {
      apiPayload = {
        ...apiPayload,
        impersonated_by: localStorage.getItem(IMPERSONATED_BY)
      }
    }

    const request = {
      url: `/orders/${orderId}`,
      body: apiPayload
    }

    const response = yield call(api.utility.put, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({ type: "MAINTENANCE_CANCELATION_SUCCEEDED" })
    orderCancelledEvents(response.body)

    const afterRequestData = {
      alertMessage: i18n.t("notificationsReminder:maintenanceCanceled"),
      alertType: SUCCESS
    }

    yield call(action.callback, SUCCESS, afterRequestData)
  } catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({
      type: "MAINTENANCE_CANCELATION_FAILED"
    })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors),
      alertType: ERROR
    }

    yield call(action.callback, FAILURE, afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // maintenanceCancelation()

export default function* maintenanceApprovalSaga() {
  yield takeEvery("MAINTENANCE_UPDATE_SAGA", maintenanceUpdate)
  yield takeEvery("MAINTENANCE_APPROVAL_SAGA", maintenanceApproval)
  yield takeEvery("MAINTENANCE_CANCELATION_SAGA", maintenanceCancelation)
}
